import clsx from 'clsx';
import { fr } from 'date-fns/locale';
import { bool, func, instanceOf, oneOf, shape, string } from 'prop-types';
import { useMemo } from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useFormContext } from 'react-hook-form';

import { FieldErrorMessage, Icon } from 'components';
import i18n from 'translations';

import 'assets/styles/components/form/date-picker.scss';

registerLocale('fr', fr);

const DatePicker = ({
  selected = null,
  onChange = null,
  placeholder = '',
  label = '',
  name = '',
  containerClass = '',
  icon = null,
  disabled = false,
  id = '',
  ...props
}) => {
  const { formState: errors } = useFormContext();
  const error = errors?.[name]?.message || errors?.[name]?.type;

  const language = useMemo(() => {
    if (i18n.resolvedLanguage === 'fr') return { locale: fr, dateFormat: 'dd/MM/yyyy' };
  }, []);

  return (
    <div className={clsx(containerClass, disabled && 'disabled cursor-not-allowed')}>
      {label.length > 0 && <label className="date-picker-label">{label}</label>}

      <div className={clsx('date-picker-container', icon?.name && 'has-icon')}>
        {icon?.name && <Icon name={icon.name} iconStyle={icon?.style} classes="date-picker-icon" />}
        <ReactDatePicker
          selected={selected}
          onChange={onChange}
          locale={language.locale}
          dateFormat={language.dateFormat}
          disabled={disabled}
          placeholderText={placeholder}
          className={clsx('date-picker-input', error && 'invalid')}
          popperProps={{ strategy: 'fixed' }}
          autoComplete="off"
          id={id}
          {...props}
        />
        <Icon name="angle-down" classes="date-picker-icon arrow" />
      </div>

      <FieldErrorMessage errors={errors} name={name} />
    </div>
  );
};

DatePicker.propTypes = {
  selected: instanceOf(Date),
  onChange: func,
  placeholder: string,
  label: string,
  name: string,
  containerClass: string,
  icon: shape({ name: string.isRequired, style: oneOf(['fas', 'fad']) }),
  disabled: bool,
  id: string
};

export default DatePicker;
